import { useTranslation } from 'react-i18next';

import { SectionCard } from '../../components/design-system/admin/SectionCard';
import { useAdminStoreKnowledgeApi } from '../../common/hooks/use-store-knowledge-api.hook';
import { StoreKnowledgePanel } from './StoreKnowledgePanel';

/** The super-admin view of a vendor's store knowledge: read it, and read the site again. */
export function AdminStoreKnowledgeCard({ vendorId }: { vendorId: string }) {
    const { t } = useTranslation();
    const api = useAdminStoreKnowledgeApi(vendorId);
    return (
        <SectionCard title={t('SHOPPER_UI.STORE.ADMIN_TITLE')} description={t('SHOPPER_UI.STORE.ADMIN_DESC')} testId="admin-store-knowledge">
            <StoreKnowledgePanel api={api} />
        </SectionCard>
    );
}
